const PATH =
  'fe.components.measure.view.cycles.cycle_scores_form.dimension_card';

const messages = {
  indicators: {
    key: `${PATH}.indicators`,
    defaultValue: 'Indicators'
  },
  score: {
    key: `${PATH}.score`,
    defaultValue: 'Score'
  },
  range: {
    key: `${PATH}.range`,
    defaultValue: 'Range'
  },
  overallRange: {
    key: `${PATH}.overall_range`,
    defaultValue: 'Overall Range'
  },
  indicatorError: {
    key: `${PATH}.indicator_error`,
    defaultValue: 'Complete indicator range selection.'
  },
  errors: {
    required: {
      key: `${PATH}.errors.required`,
      defaultValue: 'Dimension score is required.'
    }
  },
  low: {
    key: `${PATH}.low`,
    defaultValue: 'Low'
  },
  mid: {
    key: `${PATH}.mid`,
    defaultValue: 'Mid'
  },
  high: {
    key: `${PATH}.high`,
    defaultValue: 'High'
  },
  observationNotes: {
    key: `${PATH}.observation_notes`,
    defaultValue: 'Observation Notes'
  },
  noNotesYet: {
    key: `${PATH}.no_notes_yet`,
    defaultValue:
      'No notes yet. Add one for this dimension in the section above.'
  },
  warnings: {
    uncommonAbove: {
      key: `${PATH}.warnings.uncommon_above`,
      defaultValue: 'Scores above {{number}} are uncommon for {{dimension}}.'
    },
    uncommonBelow: {
      key: `${PATH}.warnings.uncommon_below`,
      defaultValue: 'Scores below {{number}} are uncommon for {{dimension}}.'
    },
    informalAboveLow: {
      key: `${PATH}.warnings.informal_above_low`,
      defaultValue: 'Ranges above Low are uncommon for {{dimension}}.'
    },
    informalAboveMid: {
      key: `${PATH}.warnings.informal_above_mid`,
      defaultValue: 'Ranges above Mid are uncommon for {{dimension}}.'
    }
  }
};

export default messages;
